import React from "react"
import { Card as CardOg } from "@chakra-ui/react"
import type { StyleProps } from "@mallardbay/lib-react-components"
import { useColors } from "@mallardbay/lib-react-components"

import type { PropsWithChildrenAndStyle } from "~components/shared/todo-lib-react-components/types"

export default function Card({ style, children }: PropsWithChildrenAndStyle) {
    const styles = useStyles()

    return <CardOg sx={{ ...styles.root, ...style }}>{children}</CardOg>
}

function useStyles() {
    const colors = useColors()

    const root: StyleProps = {
        backgroundColor: colors.cardBackgroundColor,
        paddingX: 6,
        paddingY: 4,
        border: `1px solid ${colors.borderColor}`,
        boxShadow: "none",
    }

    return { root }
}
